import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right--custom",
  "use": "icon-arrow--right--custom-usage",
  "viewBox": "0 0 11 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 16\" id=\"icon-arrow--right--custom\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.328 15.56.5 12.73l4.827-4.827L.5 3.076 3.328.248l7.656 7.656-7.656 7.656Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol